/**
 * Keep MultiVariants colour labels + size headers aligned with the qty grid.
 *
 * 1) Vertical: sticky colour labels are min-height:107px and don't grow when
 *    stock/price lines make rows taller → labels drift up.
 * 2) Horizontal: theme used margin-right:82px on row titles while the Colour
 *    corner was ~98px wide → size headers sat ~10px left of their columns.
 */
(function () {
  var scheduled = false;

  function rows() {
    return document.querySelectorAll(
      '.multivariants_block_option_list.multivariats_grid_holder_row'
    );
  }

  function titles() {
    return document.querySelectorAll(
      '.multivariants_grid_row_title_holder > .multivariants_grid_row_title'
    );
  }

  function syncRows() {
    var rowEls = rows();
    var titleEls = titles();
    if (!rowEls.length || !titleEls.length) return;

    for (var i = 0; i < titleEls.length; i++) {
      var row = rowEls[i];
      if (!row) continue;
      var h = row.getBoundingClientRect().height;
      if (h < 1) continue;
      var px = Math.round(h) + 'px';
      titleEls[i].style.setProperty('height', px, 'important');
      titleEls[i].style.setProperty('min-height', px, 'important');
      titleEls[i].style.setProperty('max-height', px, 'important');
      titleEls[i].style.setProperty('box-sizing', 'border-box', 'important');
    }
  }

  function setFlexBasis(el, px) {
    if (!el) return;
    var v = Math.round(px) + 'px';
    el.style.setProperty('width', v, 'important');
    el.style.setProperty('min-width', v, 'important');
    el.style.setProperty('max-width', v, 'important');
    el.style.setProperty('flex', '0 0 ' + v, 'important');
    el.style.setProperty('box-sizing', 'border-box', 'important');
  }

  function syncColumns() {
    var firstRow = document.querySelector(
      '.multivariants_block_option_list.multivariats_grid_holder_row'
    );
    if (!firstRow) return;

    var contents = firstRow.querySelectorAll(':scope > .multivariats_grid_content');
    if (!contents.length) return;

    var holders = document.querySelectorAll('.multivariants_grid_column_title_holder');
    // Last holder with size labels (XXS, XS, ...)
    var sizeHolder = null;
    for (var h = 0; h < holders.length; h++) {
      if (holders[h].querySelector('.multivariants_grid_column_title')) {
        sizeHolder = holders[h];
      }
    }
    if (!sizeHolder) return;

    var headers = sizeHolder.querySelectorAll('.multivariants_grid_column_title');
    var corners = document.querySelectorAll('.multivariants_grid_column_title_corner');
    var placeholder = firstRow.querySelector(':scope > .multivariants_grid_row_title');

    // Colour spacer = distance from row left edge to first qty cell
    var rowLeft = firstRow.getBoundingClientRect().left;
    var firstCellLeft = contents[0].getBoundingClientRect().left;
    var spacer = firstCellLeft - rowLeft;
    if (spacer > 1) {
      if (placeholder) {
        placeholder.style.setProperty('margin-right', '0', 'important');
        setFlexBasis(placeholder, spacer);
      }
      for (var c = 0; c < corners.length; c++) {
        setFlexBasis(corners[c], spacer);
      }
      // Sticky colour labels share the same column width
      var sticky = titles();
      for (var t = 0; t < sticky.length; t++) {
        setFlexBasis(sticky[t], spacer);
      }
    }

    // Re-measure after spacer change, then match each size header to its cell
    for (var i = 0; i < headers.length; i++) {
      var cell = contents[i];
      if (!cell) continue;
      var w = cell.getBoundingClientRect().width;
      if (w < 1) continue;
      setFlexBasis(headers[i], w);
    }
  }

  function sync() {
    syncColumns();
    syncRows();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      sync();
    });
  }

  function boot() {
    sync();
    [100, 400, 1000, 2000].forEach(function (ms) {
      setTimeout(sync, ms);
    });

    window.addEventListener('resize', schedule);

    var root =
      document.getElementById('MULTIVARIANTS_APP_BLOCK_CONTENT') ||
      document.getElementById('EFOLI_APP_MULTIVARIANTS_BLOCK_PRODUCT') ||
      document.getElementById('MULTIVARIANTS_APP_SECTION_PLACE');
    if (root && typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(schedule);
      ro.observe(root);
      rows().forEach(function (row) {
        ro.observe(row);
      });
    }
    if (root && typeof MutationObserver !== 'undefined') {
      new MutationObserver(schedule).observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', sync);
})();
